export default __webpack_public_path__ + "static/media/privateDining.06eccb66.svg";